export enum WbaEvents {
  INIT = "init",
  PAGEVIEW = "pageview",
  NEWGENERATION_CLICK_FORM_BTN = "NEWGENERATION_CLICK_FORM_BTN",
  NEWGENERATION_FORM_SEND = "NEWGENERATION_FORM_SEND",
  NEWGENERATION_FORM_SENDED = "goal_reach",
  NEWGENERATION_VIDEO_PLAY = "NEWGENERATION_VIDEO_PLAY",
  NEWGENERATION_VIDEO_STOP = "NEWGENERATION_VIDEO_STOP",
  NEWGENERATION_NOMINATOIN_LIST_OPEN = "NEWGENERATION_NOMINATOIN_LIST_OPEN",
  NEWGENERATION_NOMINATOIN_ITEM_OPEN = "NEWGENERATION_NOMINATOIN_ITEM_OPEN",
  NEWGENERATION_FAQ_OPEN = "NEWGENERATION_FAQ_OPEN",
  NEWGENERATION_ECOSYS_CLICK = "NEWGENERATION_ECOSYS_CLICK",
}
